<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Points Tables
              </div>
              <q-btn
                class="q-ml-md"
                color="primary"
                text-color="white"
                no-caps
                @click="newDialog = true"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="dataLoading"
                @click="loadData"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="gridData">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 260px) !important"
                >
                  <datatable
                    :filter="search"
                    :flat="true"
                    :data="gridData"
                    :columns="columns"
                    @rowDoubleClick="handleDoubleClick"
                  >
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td :props="data.props">
                        <q-btn
                          @click="deletePointsTable(data.props.row.id)"
                          round
                          flat
                          color="negative"
                        >
                          <q-icon name="mdi-trash-can-outline"></q-icon>
                          <q-tooltip>Remove Points Table</q-tooltip>
                        </q-btn>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="newDialog" persistent max-width="90vw">
      <q-card v-if="newDialog" tile style="width: 600px; max-width: 90vw">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              New Points Table
            </div>
            <q-space />
            <q-btn
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <pointsTableForm
            ref="newForm"
            @close="newDialog = false"
            @loadingStateChanged="(state) => (createLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" persistent max-width="600px">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 600px; max-width: 90vw"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Points Table
            </div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="close"> </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <pointsTableForm
            ref="editForm"
            :id="viewFormData.id"
            @close="close"
            @loadingStateChanged="(state) => (saveLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Save
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import datatable from "@/components/datatable/datatable.vue";
  import pointsTableForm from "@/components/pointsTable/pointsTableForm.vue";
  import moment from "moment";

  // import { Notify } from "quasar";

  export default {
    components: {
      datatable,
      pointsTableForm,
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        siteCFG: "settings/siteCFG",
        gridData: "pointsTable/list",
        dataLoading: "pointsTable/listLoading",
      }),
    },
    data: () => ({
      // data-table
      columns: [
        {
          name: "name",
          label: "Name",
          align: "left",
          field: "name",
          style:
            "min-width: 250px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
        {
          name: "pointsForFinalsOnly",
          label: "Finals Only",
          align: "left",
          field: "pointsForFinalsOnly",
          format: (val) => {
            return val == 1 ? "Y" : "N";
          },
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "json",
          label: "Points",
          align: "left",
          field: "JSON",
          format: (val) => {
            let points = [];
            JSON.parse(val).forEach((element) => {
              points.push(`${element.name}=${element.value}pts`);
            });
            return points.join(", ");
          },
          style:
            "min-width: 250px;max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: false,
        },
        {
          name: "created_at",
          label: "Created At",
          align: "left",
          field: "created_at",
          format: (val) =>
            val != null ? moment.utc(val).local().format("DD-MMM, YYYY") : "",
          style:
            "min-width: 250px;max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "updated_at",
          label: "Updated At",
          align: "left",
          field: "updated_at",
          format: (val) =>
            val != null ? moment.utc(val).local().format("DD-MMM, YYYY") : "",
          style:
            "min-width: 250px;max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "left",
          field: "actions",

          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
      ],
      search: "",

      createLoading: false,

      newDialog: false,

      // View and Edit
      viewFormData: {},
      saveLoading: false,
      viewDetailsDialog: false,

      // Deleting Codes
      deletingDQCodes: null,
    }),
    watch: {
      $route: function () {
        this.handleRoute();
      },
    },
    mounted() {
      this.loadData();
      this.handleRoute();
    },
    methods: {
      handleDoubleClick(row) {
        this.$router.push(`${this.$route.path}/${row.id}`);
      },
      loadData() {
        this.$store.dispatch("pointsTable/loadAll");
      },
      handleRoute() {
        if (this.$route.params.id) {
          this.viewFormData = { id: this.$route.params.id };
          this.$nextTick(() => {
            this.viewDetailsDialog = true;
          });
        } else {
          this.viewDetailsDialog = false;
        }
      },
      close() {
        this.$router.push("/management/pointsTable");
      },
      deletePointsTable(id) {
        this.$swal({
          title: "Warning",
          text: "You are about to Delete a Points Table, do you wish to continue?",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then((res) => {
          if (res.value) {
            this.$store
              .dispatch("pointsTable/delete", {
                id: id,
              })
              .then((result) => {
                if (result.Result == "Success") {
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: "There was an Error, Please try again later",
                  });
                }
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  #depthCard:hover {
    background: #5cb3ff;
    color: white;
  }

  .formHeight {
    min-height: calc(100vh - 175px);
    max-height: 1000px;
  }
</style>
